<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M21.7778 21.1561L15.5489 14.9234C16.7296 13.5491 17.4405 11.777 17.4405 9.83605C17.4405 5.52019 13.9224 2 9.60916 2C7.51277 2 5.54892 2.81977 4.06699 4.29054C2.59711 5.7613 1.77783 7.72634 1.77783 9.82399C1.77783 14.1398 5.2959 17.66 9.60916 17.66C11.5489 17.66 13.332 16.9488 14.6935 15.7673L20.9224 22L21.7778 21.1441V21.1561ZM9.60916 16.4545C5.95855 16.4545 2.98265 13.4768 2.98265 9.82399C2.98265 8.05184 3.6694 6.38819 4.92241 5.13442C6.17542 3.88065 7.83807 3.19349 9.60916 3.19349C13.2598 3.19349 16.2357 6.17119 16.2357 9.82399C16.2357 13.4768 13.2598 16.4545 9.60916 16.4545Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
